<template>
    <div>
        <v-toolbar
                dense
                tabs
                color="primary darken-2"
                dark
        >
            <v-toolbar-title class="pa-0 text-xs-left">
                <a href="javascript: history.go(-1)" class="pa-0">
                    <v-btn flat fab small class="pa-0">
                        <i class="fas fa-arrow-left headline"></i>
                    </v-btn>
                </a>                
                Monitor: Dashboard
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tabs
                    v-model="tabs"
                    color="transparent"
                    slider-color="white"
                    slot="extension"
            >
                <v-tab 
                        v-for="tabsItem in tabsItems"
                        :key="tabsItem.id"
                        :to="tabsItem.link"
                >
                    <span class="pl-1 pr-1" >{{ tabsItem.title }}</span>
                </v-tab>
            </v-tabs>
        </v-toolbar>

        <v-container>
            <v-layout row>
                <v-flex xs12 md8 offset-md2>
                    <v-slide-y-transition mode="out-in">
                        <router-view/>
                    </v-slide-y-transition>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tabs: null,
                tabsItems: [
                    {id: 1, title: 'Overall', link: '/monitor/dashboard/overall'},
                    {id: 2, title: 'Expenses', link: '/monitor/dashboard/expenses'},
                    {id: 3, title: 'Income', link: '/monitor/dashboard/income'}
                ]
            }
        }
    }
</script>

<style scoped>

</style>
